// Actions
export const setFormValidation = ({ commit }, payload) => {
  commit('SET_FORM_VALIDATION', payload)
}
export const addFormValidation = ({ commit }, payload) => {
  commit('ADD_FORM_VALIDATION', payload)
}
export const setFormValidationLoading = ({ commit }, payload) => {
  commit('SET_FORM_VALIDATION_LOADING', payload)
}

export const setIndicadores = ({ commit }, payload) => {
  commit('SET_INDICADORES', payload)
}
export const addIndicadores = ({ commit }, payload) => {
  commit('ADD_INDICADORES', payload)
}
export const setIndicadoresLoading = ({ commit }, payload) => {
  commit('SET_INDICADORES_LOADING', payload)
}

export const setQuestions = ({ commit }, payload) => {
  commit('SET_QUESTIONS', payload)
}
export const addQuestions = ({ commit }, payload) => {
  commit('ADD_QUESTIONS', payload)
}
export const setQuestionsLoading = ({ commit }, payload) => {
  commit('SET_QUESTIONS_LOADING', payload)
}

// Actions
export const setPerformanceManagement = ({ commit }, payload) => {
  commit('SET_PERFORMANCE_MANAGEMENT', payload)
}
export const addPerformanceManagement = ({ commit }, payload) => {
  commit('ADD_PERFORMANCE_MANAGEMENT', payload)
}
export const setPerformanceManagementLoading = ({ commit }, payload) => {
  commit('SET_PERFORMANCE_MANAGEMENT_LOADING', payload)
}

export const setFilterRH = ({ commit }, payload) => {
  commit('SET_FILTER_RH', payload)
}
export const setTaskValuation = ({ commit }, payload) => {
  commit('SET_TASK_VALUATION', payload)
}
export const addTaskValuation = ({ commit }, payload) => {
  commit('ADD_TASK_VALUATION', payload)
}
export const setTaskValuationLoading = ({ commit }, payload) => {
  commit('SET_TASK_VALUATION_LOADING', payload)
}

export const setProfessionalQuestionsGoals = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_QUESTIONS_GOALS', payload)
}
export const addProfessionalQuestionsGoals = ({ commit }, payload) => {
  commit('ADD_PROFESSIONAL_QUESTIONS_GOALS', payload)
}
export const setProfessionalQuestionsGoalsLoading = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_QUESTIONS_GOALS_LOADING', payload)
}

export const setCommercialEffort = ({ commit }, payload) => {
  commit('SET_COMMERCIAL_EFFORT', payload)
}
export const addCommercialEffort = ({ commit }, payload) => {
  commit('ADD_COMMERCIAL_EFFORT', payload)
}
export const setCommercialEffortLoading = ({ commit }, payload) => {
  commit('SET_COMMERCIAL_EFFORT_LOADING', payload)
}

